import { render, staticRenderFns } from "./massManage.vue?vue&type=template&id=3d7ef535&scoped=true"
import script from "./massManage.vue?vue&type=script&lang=js"
export * from "./massManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ef535",
  null
  
)

export default component.exports